import React from "react";

import Grid2 from "@mui/material/Unstable_Grid2";
import MKBox from "../../../components/MKBox";
import ModelCard from "../../../views/Cards/ModelCard";
import models from "../../../store/constant/models";

const Models = () => {
  const modelList = models;
  return (
    <MKBox mt={2}>
      <Grid2
        container
        mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 48 }}
        my={1}
        maxWidth={1600}
        justifyContent="center"
        sx={{ gap: "20px" }}
      >
        {modelList.map((m) => (
          <Grid2 xs={4} my={1} item key={m.id}>
            <ModelCard
              model={m}
              action={{
                type: "internal",
                route: `/computing/new/${m.id}`,
                color: "secondary",
                label: "Select",
              }}
            />
          </Grid2>
        ))}
      </Grid2>
    </MKBox>
  );
};
export default Models;
